module.exports = __webpack_public_path__ + "img/handCard.26ade48f.png";